module.exports = __webpack_public_path__ + "static/media/timer-bg.827438df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/timer-bg.png
// module id = 1916
// module chunks = 6